import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom={
      counters: this.el.querySelectorAll('.statistics-card__count'),
      featuredSection: this.el,
      hiddenCounters: this.el.querySelectorAll('.statistics-card__hidden-count'),
      countContainer: this.el.querySelectorAll('.statistics-card__absolute-position')
    }
    this.animated = false;
  }

  addListeners() {
    window.addEventListener('load', this.handleCounters.bind(this));
    window.addEventListener('scroll', this.handleCounters.bind(this));
  }

  handleCounters(e) {
    if (this.isInViewport(this.dom.featuredSection) && !this.animated) {
      this.startCounters();
      this.animated = true;
    } else if (!this.isInViewport(this.dom.featuredSection)) {
      this.resetCounter();
      this.animated = false;
    }
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const elementArea = rect.width * rect.height;
    const intersectionArea = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0)) *
                           Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
    const visibilityPercentage = intersectionArea / elementArea * 100;
    return visibilityPercentage > 50;
  }

  startCounters() {
    this.resetCounter();
    this.dom.counters.forEach((counter, index) => {
      const iterations = (counter.getAttribute('data-iterations') ? counter.getAttribute('data-iterations'): 8);
      const updateCount = () => {
        const target = parseFloat(counter.getAttribute('data-count'));
        const decimalPlaces = this.getDecimalPlaces(target);
        const count = parseFloat(counter.getAttribute('data-hidden-count'));
        const increment = parseFloat(target / iterations);
        const updatedCount = parseFloat((count + increment)).toFixed(decimalPlaces);
        const updatedHiddenCount = parseFloat(count + increment);
        if (updatedCount < target && count === 0) {
          counter.classList.remove('start-animation');
          counter.offsetWidth; // Trigger reflow
          counter.innerText = updatedCount;
          counter.setAttribute('data-hidden-count', updatedHiddenCount);
          count
          counter.classList.add('start-animation');
          setTimeout(updateCount, 250);
        }

        if (updatedCount < target && count !== 0) {
          counter.classList.remove('start-animation');
          counter.classList.remove('counter-animation');
          counter.offsetWidth; // Trigger reflow
          counter.style.transform = 'translateY(-100%)';
          counter.innerText = updatedCount;
          counter.setAttribute('data-hidden-count', updatedHiddenCount);
          counter.classList.add('counter-animation');
          setTimeout(updateCount, 250);
        } else if (updatedCount >= target) {
          counter.classList.remove('start-animation');
          counter.classList.remove('counter-animation');
          counter.classList.remove('end-animation');
          counter.innerText = target;
          counter.setAttribute('data-hidden-count', target);
          counter.classList.add('end-animation');
        }
      };
      updateCount();
    });
  }

  resetCounter() {
    this.dom.counters.forEach(counter => {
      const initialCount = (counter.getAttribute('data-reset') ? counter.getAttribute('data-reset'): 0);
      counter.classList.remove('end-animation');
      counter.style.transform = 'translateY(0)';
      counter.setAttribute('data-hidden-count', initialCount);
    });
  }

  getDecimalPlaces(value) {
    const stringValue = value.toString();
    const indexOfDecimal = stringValue.indexOf('.');
    if (indexOfDecimal === -1) {
      return 0;
    }
    return stringValue.length - indexOfDecimal - 1;
  }
}

export default Module;
